import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'

const ReceivePaste = Loadable(lazy(() => import('./InvoiceValidate')))

const ReceiveInvoiceRoutes = [
    {
        path: '/download-invoice',
        element: <ReceivePaste />,
        auth: authRoles.admin,
    },
]

export default ReceiveInvoiceRoutes
